import React, { Component } from "react";
import { List, ListItem, RadioGroup, CardActionArea } from "@mui/material";
import "./css/InverterSelectorForm.css";
import { Card, CardHeader, CardContent } from "@mui/material";
import LinearProgressWithLabel from "./linearProgressBar";

export class ModelSeriesSelectView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalcap4IS: "",
      phase4IS: "",
      inputVolt4IS: "",
      shakerTableHide: false,
      modelList: {},
      showNextButton: false,
      showBar: false,
      disableButton: false,
    };
    this.props.showNextButton(false);
  }

  modelSelection = (item, index) => {
    this.setState({ showBar: true }, () => {
      this.props.setProductType(item["Name"], index);
      //console.log(index);
      this.setState({disableButton: true})
    });
  };

  render() {
    return (
      //App starts here
      <Card elevation={10}>
        <CardHeader
          titleTypographyProps={{
            fontFamily: "ford-normal",
          }}
          className="paperh-title"
          title="Suggested Models"
        />

        <CardContent className="ms-cardContent">
          <List>
            <RadioGroup>
              {this.props.userOPdata.map((item, index) => (
                <ListItem key={item["Name"]}>
                  <Card variant="outlined">
                    <CardActionArea
                      onClick={(event) => this.modelSelection(item, index)}
                      disabled={this.state.disableButton}
                    >
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          flexWrap: "wrap",
                          padding: "30px",
                        
                        }}
                      >
                        <img
                          id="prodimg"
                          src={
                            this.props.data.userOPdata[
                              index
                            ]["Image URL"]
                          }
                          style={{ width: "40%", minWidth: "300px" }}
                        />
                        <div
                          id="info"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <h1
                            style={{ fontSize: "xx-large" }}
                            className="infoText"
                          >
                            {
                              this.props.data.userOPdata[
                                index
                              ]["Name"]
                            }
                          </h1>
                          <div className="infoText">
                            <b>Capacity: </b>
                            {
                              this.props.data.userOPdata[
                                index
                              ]["Power Rating"]
                            }
                            W
                          </div>
                          <div className="infoText">
                            <b>Input: </b>
                            {this.props.data.ivData}
                          </div>
                          <div className="infoText">
                            <b>Output: </b>
                            {this.props.data.ovData}
                          </div>
                          <div className="infoText">
                            <b>Enclosure: </b>
                            {this.props.data.cabType}
                          </div>

                          <div className="infoText">
                            <b>Max number of Aux breakers: </b>
                            {
                              this.props.data.userOPdata[
                                index
                              ]["Aux Circuit Breakers"]
                            }
                          </div>
                        </div>
                      </div>
                    </CardActionArea>
                  </Card>
                </ListItem>
              ))}
            </RadioGroup>
          </List>
          {/* {this.state.showBar && <LinearProgressWithLabel />} */}
        </CardContent>
      </Card>
    );
  }
}

export default ModelSeriesSelectView;
